<template>
  <div>
    <noscript>
      <img style="display:none;" src="https://score.juicyscore.com/savedata/?isJs=0"/>
    </noscript>
    <div v-if="isDataReady">
      <uiHead
        v-on:scrollingTo="WsScrollTo"
        :phoneForProduct="phoneForProduct"
      ></uiHead>
      <uiTitle
        v-on:scrollingTo="WsScrollTo"
        :currentScreen="currentScreen"
      ></uiTitle>

      <!--    <div class="banner">-->
      <!--      <div>-->
      <!--        <p>-->
      <!--          Станьте участником розыгрыша<br>-->
      <!--          10 сертификатов по 3000 рублей-->
      <!--        </p>-->
      <!--        <p>-->
      <!--          <span>Установите</span> мобильное приложение<br> и <span>внесите</span> онлайн-платеж-->
      <!--        </p>-->
      <!--        <div>-->
      <!--          <a target="_blank" href="https://play.google.com/store/apps/details?id=ru.finmoll.customer&hl=ru&clckid=6e94573d">-->
      <!--            <svg viewBox="0 0 246 73" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M236.889 0H9.111C4.08 0 0 4.085 0 9.125v54.75C0 68.915 4.08 73 9.111 73H236.89c5.032 0 9.111-4.085 9.111-9.125V9.125C246 4.085 241.921 0 236.889 0z" fill="#000"/><path d="M124.166 39.694a7.736 7.736 0 00-4.292 1.325 7.757 7.757 0 00-3.262 7.966 7.757 7.757 0 006.093 6.075 7.735 7.735 0 007.94-3.305 7.767 7.767 0 001.302-4.305 7.658 7.658 0 00-2.248-5.53 7.638 7.638 0 00-5.533-2.226zm0 12.464a4.695 4.695 0 01-4.57-2.667 4.717 4.717 0 01.8-5.236 4.701 4.701 0 015.157-1.178 4.703 4.703 0 012.987 4.373 4.508 4.508 0 01-1.195 3.278 4.486 4.486 0 01-3.179 1.43zm-16.965-12.464a7.736 7.736 0 00-7.141 4.8 7.764 7.764 0 001.69 8.447 7.742 7.742 0 008.438 1.673 7.745 7.745 0 003.472-2.857 7.766 7.766 0 001.304-4.307 7.64 7.64 0 00-2.248-5.53 7.638 7.638 0 00-5.533-2.226h.018zm0 12.464a4.694 4.694 0 01-4.582-2.653 4.72 4.72 0 01.787-5.242 4.703 4.703 0 015.159-1.186 4.703 4.703 0 012.992 4.373 4.508 4.508 0 01-1.196 3.278 4.472 4.472 0 01-3.178 1.43h.018zM86.993 42.084v3.285h7.872a6.885 6.885 0 01-1.822 4.143 8.053 8.053 0 01-6.068 2.41 8.74 8.74 0 01-6.185-2.566 8.767 8.767 0 010-12.389 8.74 8.74 0 016.185-2.566 8.375 8.375 0 015.959 2.354l2.314-2.317a11.461 11.461 0 00-8.255-3.413 12.03 12.03 0 00-8.818 3.36 12.062 12.062 0 00-3.695 8.694 12.078 12.078 0 003.695 8.694 12.041 12.041 0 008.818 3.36 10.92 10.92 0 008.4-3.376 10.96 10.96 0 002.843-7.701 10.726 10.726 0 00-.182-2.063l-11.061.091zm82.565 2.555a7.284 7.284 0 00-6.633-4.946 7.282 7.282 0 00-6.87 4.823 7.304 7.304 0 00-.419 2.934 7.603 7.603 0 002.2 5.514 7.574 7.574 0 005.49 2.242 7.698 7.698 0 006.451-3.43l-2.643-1.826a4.424 4.424 0 01-3.808 2.154 3.93 3.93 0 01-3.754-2.355l10.369-4.288-.383-.822zm-10.569 2.592a4.262 4.262 0 011.073-3.114 4.253 4.253 0 012.972-1.412 3.003 3.003 0 012.879 1.642l-6.924 2.884zm-8.419 7.519h3.408V31.937h-3.408V54.75zm-5.576-13.322h-.127a5.474 5.474 0 00-4.082-1.825 7.757 7.757 0 00-5.244 2.402 7.778 7.778 0 005.244 13.128 5.277 5.277 0 004.082-1.825h.109v1.114c0 2.974-1.585 4.562-4.136 4.562a4.277 4.277 0 01-3.9-2.756l-2.97 1.241a7.389 7.389 0 002.736 3.342 7.371 7.371 0 004.134 1.239c3.99 0 7.289-2.354 7.289-8.085V40.15h-3.135v1.278zm-3.899 10.73a4.712 4.712 0 01-3.066-1.516 4.73 4.73 0 013.066-7.9 4.363 4.363 0 013.059 1.48 4.372 4.372 0 011.077 3.228 4.347 4.347 0 01-2.463 4.293 4.33 4.33 0 01-1.691.415h.018zm44.426-20.22h-8.146V54.75h3.408V46.1h4.756a7.075 7.075 0 005.337-1.885 7.1 7.1 0 001.67-8.03 7.1 7.1 0 00-4.143-3.862 7.075 7.075 0 00-2.864-.386h-.018zm0 10.95h-4.756v-7.775h4.828c1.037 0 2.031.412 2.764 1.147a3.918 3.918 0 010 5.536 3.905 3.905 0 01-2.764 1.146l-.072-.054zm21.01-3.285a6.37 6.37 0 00-6.068 3.485l3.025 1.26a3.227 3.227 0 013.097-1.68 3.28 3.28 0 013.645 2.939v.237a7.517 7.517 0 00-3.553-.876c-3.262 0-6.56 1.825-6.56 5.128a5.283 5.283 0 001.766 3.705 5.256 5.256 0 003.882 1.314 4.788 4.788 0 004.374-2.19h.109v1.825h3.28v-8.778c0-3.997-3.025-6.315-6.906-6.315l-.091-.054zm-.419 12.5c-1.112 0-2.661-.565-2.661-1.934 0-1.825 1.932-2.427 3.645-2.427a6.04 6.04 0 013.097.767 4.122 4.122 0 01-3.99 3.65l-.091-.055zm19.37-11.953l-3.9 9.892h-.109l-4.045-9.892h-3.645l6.068 13.834-3.462 7.683h3.553l9.33-21.517h-3.79zm-30.632 14.6h3.408V31.937h-3.408V54.75zM76.734 26.043h-1.348v-3.65h1.148a5.222 5.222 0 001.384-4.198v-5.42h7.29v9.6h1.22v3.65H85.08v-2.3h-8.346v2.318zm2.533-7.793a7.31 7.31 0 01-1.039 4.198h5.467v-8.322h-4.428v4.124zm18.058 4.052a5.68 5.68 0 01-8.018 0 5.917 5.917 0 010-8.122 5.647 5.647 0 016.18-1.237 5.647 5.647 0 011.838 1.237 5.9 5.9 0 010 8.122zm-6.979-.913a4.206 4.206 0 005.94 0 4.676 4.676 0 000-6.278 4.206 4.206 0 00-5.94 0 4.676 4.676 0 000 6.278zm15.671 2.573a5.566 5.566 0 01-4.06-1.64 5.582 5.582 0 01-1.625-4.072 5.586 5.586 0 013.488-5.308 5.564 5.564 0 012.197-.404 5.041 5.041 0 014.009 1.825l-.984.949a3.647 3.647 0 00-3.043-1.387 4.133 4.133 0 00-3.025 1.204 4.694 4.694 0 000 6.333 4.138 4.138 0 003.025 1.204 4.314 4.314 0 003.335-1.624l.984.986a5.32 5.32 0 01-1.823 1.423 5.729 5.729 0 01-2.478.511zm10.022-.237h-1.403v-9.6h-3.061v-1.35h7.507v1.35h-3.043v9.6zm12.701-10.95l-4.136 9.234a2.75 2.75 0 01-2.515 1.953 2.8 2.8 0 01-1.093-.237l.364-1.296c.222.13.473.199.729.201.268.02.535-.044.765-.182.22-.187.389-.425.492-.694l.401-.876-3.644-8.085h1.658l2.697 6.278 2.624-6.296h1.658zm1.586 10.95v-10.95h7.908v10.95h-1.403v-9.6h-5.102v9.6h-1.403zm10.404 0v-10.95h1.404v4.69h5.466v-4.69h1.403v10.95H147.6v-4.946h-5.466v4.946h-1.404zm19.735-1.424a5.68 5.68 0 01-8.018 0 5.92 5.92 0 010-8.12 5.648 5.648 0 016.18-1.238 5.638 5.638 0 011.838 1.237 5.897 5.897 0 010 8.122zm-6.979-.912a4.206 4.206 0 005.94 0 4.674 4.674 0 000-6.278 4.203 4.203 0 00-5.94 0 4.679 4.679 0 000 6.278zm14.323 2.336v-10.95h3.954a3.203 3.203 0 012.223.84 2.753 2.753 0 01.948 2.135c.008.486-.132.964-.401 1.369-.268.393-.64.703-1.075.894a2.77 2.77 0 011.33.949c.35.447.537 1 .528 1.57a2.86 2.86 0 01-.984 2.226 3.367 3.367 0 01-2.332.894l-4.191.073zm1.403-6.26h2.551a1.638 1.638 0 001.275-.529 1.618 1.618 0 00.423-1.791 1.627 1.627 0 00-.35-.545 1.562 1.562 0 00-1.221-.53h-2.605l-.073 3.395zm0 4.91h2.824a1.67 1.67 0 001.312-.566 1.82 1.82 0 00.51-1.241 1.821 1.821 0 00-1.822-1.825h-2.77l-.054 3.632z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M93.316 12.691a5.46 5.46 0 00-3.878 1.616 5.735 5.735 0 000 7.867 5.499 5.499 0 007.757 0 5.717 5.717 0 000-7.867 5.465 5.465 0 00-3.879-1.616zm-2.241.084a5.824 5.824 0 016.38 1.277l.002.003a6.082 6.082 0 010 8.372l-.003.004a5.863 5.863 0 01-8.275 0l-.004-.004a6.101 6.101 0 010-8.372l.003-.003a5.832 5.832 0 011.897-1.277zm65.381-.084a5.46 5.46 0 00-3.878 1.616 5.738 5.738 0 000 7.867 5.498 5.498 0 007.757 0 5.717 5.717 0 00-.001-7.867 5.45 5.45 0 00-3.878-1.616zm-2.241.084a5.823 5.823 0 016.379 1.277l.003.003a6.082 6.082 0 010 8.372l-.003.004a5.865 5.865 0 01-8.275 0l-.004-.004a6.102 6.102 0 010-8.372l.003-.003a5.834 5.834 0 011.897-1.277zm-46.06.38a4.855 4.855 0 00-2.133-.435h-.008a5.387 5.387 0 00-3.928 1.587 5.396 5.396 0 00-1.572 3.939v.008a5.41 5.41 0 001.572 3.938 5.394 5.394 0 003.928 1.588l.003.182.004-.182a5.55 5.55 0 002.398-.494 5.147 5.147 0 001.651-1.248l-.725-.726a4.49 4.49 0 01-3.343 1.537 4.313 4.313 0 01-3.156-1.258l-.007-.006a4.88 4.88 0 01.001-6.579l.005-.006a4.317 4.317 0 013.152-1.258 3.823 3.823 0 013.06 1.302l.719-.693a4.873 4.873 0 00-1.621-1.196zm-2.138 10.99a5.756 5.756 0 01-5.457-3.625 5.762 5.762 0 01-.41-2.27 5.762 5.762 0 011.678-4.2 5.767 5.767 0 014.189-1.695 5.222 5.222 0 014.149 1.891l.108.13-1.251 1.207-.124-.158a3.464 3.464 0 00-2.891-1.318h-.014a3.943 3.943 0 00-2.888 1.149 4.51 4.51 0 000 6.08 3.946 3.946 0 002.888 1.148h.003a4.127 4.127 0 003.194-1.556l.127-.159 1.245 1.247-.105.128a5.505 5.505 0 01-1.884 1.472l-.003.002a5.917 5.917 0 01-2.554.527zm67.846-10.396a3.021 3.021 0 00-2.097-.792h-3.775V23.54l4.006-.07h.005a3.186 3.186 0 002.207-.845l.004-.004a2.692 2.692 0 00.921-2.085v-.006a2.3 2.3 0 00-.49-1.455l-.001-.001a2.588 2.588 0 00-1.243-.887l-.45-.15.434-.19c.404-.178.749-.465.998-.83.248-.373.377-.814.369-1.263v-.007a2.566 2.566 0 00-.884-1.994l-.004-.003zm.244-.27a3.385 3.385 0 00-2.346-.886h-4.135V23.91l4.371-.077H172a3.55 3.55 0 002.454-.94 3.059 3.059 0 001.045-2.363l-.001.003-.182-.003.182-.004.001.004a2.67 2.67 0 00-.567-1.681 2.954 2.954 0 00-1.046-.859c.315-.198.586-.46.797-.77l.001-.001c.29-.435.44-.948.432-1.47v.003l-.182-.003.182-.004v.004a2.932 2.932 0 00-1.009-2.272zm-96.37-.886h7.653v9.599h1.22v4.015h-1.712v-2.3h-7.982v2.318h-1.713V22.21h1.251a5.039 5.039 0 001.284-3.993l-.002-.011v-5.614zm.364.364v5.227a5.411 5.411 0 01-1.435 4.334l-.054.057h-1.044v3.285h.984v-2.317h8.71v2.299h.984v-3.285h-1.22v-9.6H78.1zm33.292-.365h7.872v1.716h-3.043v9.6h-1.768v-9.6h-3.061v-1.716zm.364.365v.986h3.061v9.6h1.039v-9.6h3.043v-.986h-7.143zm15.204-.365h2.061l-4.247 9.482a2.935 2.935 0 01-2.678 2.07l-.01.001a2.983 2.983 0 01-1.164-.253l-.146-.064.472-1.675.203.119c.194.113.414.173.639.176h.012c.225.017.45-.035.645-.15.191-.164.338-.374.428-.61l.005-.01.366-.8-3.726-8.267h2.06l2.574 5.993 2.506-6.011zm.242.365l-2.742 6.582-2.82-6.563h-1.256l3.563 7.903-.434.946c-.114.295-.3.557-.542.762l-.011.01-.012.007c-.261.157-.564.23-.868.208a1.659 1.659 0 01-.605-.123l-.261.928c.279.103.574.158.871.163a2.567 2.567 0 002.343-1.824l.004-.01 4.026-8.989h-1.256zm2.94-.365h8.273v11.315h-1.767v-9.599h-4.738v9.6h-1.768V12.591zm.365.365v10.585h1.038v-9.599h5.467v9.6h1.039V12.957h-7.544zm10.04-.365h1.768v4.69h5.102v-4.69h1.768v11.315h-1.768v-4.945h-5.102v4.945h-1.768V12.592zm.365.365v10.585h1.038v-4.945h5.831v4.945h1.039V12.957h-1.039v4.69h-5.831v-4.69h-1.038zm-50.696 2.025a4.388 4.388 0 016.198 0l.007.006a4.859 4.859 0 010 6.524l-.007.006a4.388 4.388 0 01-6.198 0l.129-.129-.135.123a4.858 4.858 0 010-6.524l.007-.006zm.26 6.28a4.024 4.024 0 005.678 0 4.493 4.493 0 000-6.025 4.024 4.024 0 00-5.677 0 4.493 4.493 0 000 6.026zm62.88-6.28a4.391 4.391 0 016.198 0l.007.006a4.858 4.858 0 01-.001 6.524l-.006.006a4.388 4.388 0 01-6.198 0l.129-.129-.135.123a4.858 4.858 0 010-6.524l.006-.006zm.261 6.281a4.023 4.023 0 005.677 0 4.494 4.494 0 000-6.026 4.026 4.026 0 00-5.677 0 4.495 4.495 0 000 6.026zm18.27-7.375a1.75 1.75 0 011.357.588 1.799 1.799 0 01.507 1.313 1.81 1.81 0 01-.585 1.277 1.82 1.82 0 01-1.408.582h-2.733l.08-3.76h2.782zm.599.479a1.378 1.378 0 00-.591-.114h-2.433l-.065 3.03h2.373a1.455 1.455 0 001.133-.47l.006-.007.006-.005a1.444 1.444 0 00.065-2.074l-.006-.006a1.387 1.387 0 00-.488-.354zm-93.402-.424h4.792v8.687h-5.972l.167-.277a7.126 7.126 0 001.013-4.093v-4.317zm.364.365v3.937a7.492 7.492 0 01-.906 4.02h4.97v-7.957h-4.064zm89.638 4.252h2.949a2.004 2.004 0 012.005 2.008v.002a2.008 2.008 0 01-.559 1.363 1.854 1.854 0 01-1.449.624h-3.006l.06-3.997zm.359.365l-.049 3.267h2.645a1.492 1.492 0 001.17-.504l.005-.006c.289-.3.453-.699.459-1.116a1.643 1.643 0 00-1.64-1.64h-2.59z" fill="#fff"/><path d="M19.024 13.76a3.654 3.654 0 00-.838 2.556v40.368a3.654 3.654 0 00.838 2.556l.127.127L41.73 36.774v-.53L19.15 13.634l-.127.128z" fill="url(#paint0_linear_29_20)"/><path d="M49.2 44.311l-7.471-7.537v-.53l7.47-7.555.165.091 8.947 5.092c2.551 1.442 2.551 3.814 0 5.274l-8.91 5.074-.201.091z" fill="url(#paint1_linear_29_20)"/><path d="M49.419 44.202l-7.69-7.702-22.705 22.74a2.968 2.968 0 003.79.109l26.623-15.147" fill="url(#paint2_linear_29_20)"/><path d="M49.419 28.799L22.796 13.65a2.967 2.967 0 00-3.79.11L41.729 36.5l7.69-7.701z" fill="url(#paint3_linear_29_20)"/><path opacity=".2" d="M49.2 44.037L22.796 59.093a3.04 3.04 0 01-3.645 0l-.127.128.127.128a3.022 3.022 0 003.645 0l26.623-15.147-.22-.165z" fill="#000"/><path opacity=".12" d="M19.024 58.984a3.654 3.654 0 01-.838-2.555v.274a3.654 3.654 0 00.838 2.555l.127-.128-.127-.146zM58.31 38.873L49.2 44.037l.164.165 8.947-5.074a3.19 3.19 0 001.822-2.628 3.396 3.396 0 01-1.822 2.373z" fill="#000"/><path opacity=".25" d="M22.796 13.906l35.515 20.22a3.39 3.39 0 011.822 2.373 3.197 3.197 0 00-1.822-2.628l-35.515-20.22c-2.551-1.442-4.628-.238-4.628 2.682v.274c.054-2.938 2.095-4.143 4.628-2.701z" fill="#fff"/><defs><linearGradient id="paint0_linear_29_20" x1="39.724" y1="15.896" x2="9.101" y2="46.473" gradientUnits="userSpaceOnUse"><stop stop-color="#00A0FF"/><stop offset=".01" stop-color="#00A1FF"/><stop offset=".26" stop-color="#00BEFF"/><stop offset=".51" stop-color="#00D2FF"/><stop offset=".76" stop-color="#00DFFF"/><stop offset="1" stop-color="#00E3FF"/></linearGradient><linearGradient id="paint1_linear_29_20" x1="61.646" y1="36.5" x2="17.566" y2="36.5" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE000"/><stop offset=".41" stop-color="#FFBD00"/><stop offset=".78" stop-color="orange"/><stop offset="1" stop-color="#FF9C00"/></linearGradient><linearGradient id="paint2_linear_29_20" x1="45.246" y1="40.697" x2="3.709" y2="82.153" gradientUnits="userSpaceOnUse"><stop stop-color="#FF3A44"/><stop offset="1" stop-color="#C31162"/></linearGradient><linearGradient id="paint3_linear_29_20" x1="13.302" y1=".328" x2="31.844" y2="18.842" gradientUnits="userSpaceOnUse"><stop stop-color="#32A071"/><stop offset=".07" stop-color="#2DA771"/><stop offset=".48" stop-color="#15CF74"/><stop offset=".8" stop-color="#06E775"/><stop offset="1" stop-color="#00F076"/></linearGradient></defs></svg>-->
      <!--          </a>-->
      <!--        </div>-->
      <!--        <p>-->
      <!--          Организатор проведения акции ООО МКК «ФИНМОЛЛ» (ОГРН:<br class="mobileOnly"> 1117746509638, номер в реестре МФО: 651403550005541).<br>-->
      <!--          Более подробную информацию об организаторе акции, месте ее<br class="mobileOnly"> проведения, правилах и порядке получения призов<br class="pcOnly">-->
      <!--          уточняйте на <a href="https://lk.msk.finmoll.com/api/assets/pdf/RulesfortheincentiveeventInstalltheapplication.pdf" target="_blank">сайте</a><br class="mobileOnly"> или по телефону 8 800 600 99 90.<br>-->
      <!--          Все представленные изображения являются компьютерной графикой. 18+</p>-->
      <!--        <div class="phone">-->
      <!--          <img src="../../../public/img/fin-moll_banner_part.png">-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </div>-->



      <div id="zform" class="alignPDL">
        <!--    оставить здесь-->
        <div class="sec_2">
          <div id="anketaSteps">
            <div id="screenFormLayout" >
              <screenFio
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'fio'"></screenFio>
              <screenSmsConfirm
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'smsConfirm'"></screenSmsConfirm>
              <screenPassport
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'passport'"></screenPassport>
              <screenWorkInfo
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'workInfo'"></screenWorkInfo>
              <screenPayment
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'payment'"></screenPayment>
              <screenSigningLoan
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'signingLoan'"></screenSigningLoan>
              <screenWaiting
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'waiting'"></screenWaiting>
              <screenThankYouPage
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'thankYouPage'"></screenThankYouPage>
              <screenRejection
                v-on:scrollingTo="WsScrollTo"
                v-on:toPdl="toPdl"
                v-if="currentScreen === 'rejection'"></screenRejection>
              <screenFullFail
                v-if="currentScreen === 'fullFail'"
                :loanInstReject="loanInstReject"
                :loanPDLReject="loanPDLReject"
              ></screenFullFail>
              <sceenCathError
                v-if="currentScreen === 'cathError'"
              ></sceenCathError>
              <screenVerificatorAwaiting
                v-if="currentScreen === 'verificationAwaiting'"
              ></screenVerificatorAwaiting>
            </div>

            <uiProductAmountSelector
              class="pcOnly"
              v-on:scrollingTo="WsScrollTo({id:'zform'})"
              :currentScreen="currentScreen"
              :showButton="false"

            ></uiProductAmountSelector>


          </div>
          <div id="steps">
            <div class="nextStepBlock" v-show="currentScreenNumber > 0 && currentScreenNumber < 6">
              <p>Шаг {{currentScreenNumber}} из {{screenArrName.length}}</p>
              <button v-on:click="nextBlock($event)">следующий шаг</button>
            </div>
            <div class="nextStepBlock" v-show="currentScreenNumber >= 6 && currentScreenNumber < 7">
              <p>Шаг {{currentScreenNumber}} из {{screenArrName.length}}</p>
              <button v-on:click="nextBlock($event)">Завершить оформление</button>
            </div>
            <div>
              <div>
                <img alt="" src="img/ico_10_lock.svg"/>
                <span>Гарантируем безопасность и сохранность ваших данных</span>
              </div>
              <div>
                <label for="chk2"><input id="chk2" type="checkbox" checked /></label>
                <p>Подтверждаю достоверность введенных данных и даю <br class="pcOnly">согласие на обработку персональных данных
                  <a target="_blank" href="https://lnd.msk.finmoll.com/assets/pdf/consent_to_PD_processing.pdf">Подробнее</a>
                </p>
              </div>
              <div>
                <label for="chk"><input id="chk" type="checkbox" checked /></label>
                <p>Подтверждаю достоверность введенных данных и даю <br class="pcOnly">согласие на получение рекламы
                  <a target="_blank" href="https://lnd.msk.finmoll.com/admd/upload/consentToAdvertising.pdf">Подробнее</a>
                </p>
              </div>
            </div>
          </div>
          <loader v-show="isLoading" ></loader>
        </div>
      </div>
      <uiHowTo
        v-on:scrollingTo="WsScrollTo"
      ></uiHowTo>
      <uiPreim></uiPreim>
      <uiUslovia></uiUslovia>
      <!--    <uiContacts-->
      <!--        v-on:scrollingTo="WsScrollTo"-->
      <!--    :phoneForProduct="phoneForProduct"-->
      <!--    ></uiContacts>-->
      <uiContactsWhite
        v-on:scrollingTo="WsScrollTo"
      ></uiContactsWhite>
    </div>
  </div>



</template>
<script>
import {mapState, mapGetters} from 'vuex';
import tracing from '@/gavnoCode/tracing.js';

/* eslint-disable vue/no-unused-components */
const awaitObjectTemplate  = (sendData) => {
  return {
    stTime:new Date().getTime(),
    endTime:0,
    status:-1,// -1 поставлен в очередь. еще не запушен, 0 работает, 1 закончил работать
    error:0,//0 ошибков нет
    result:{},//что пришло
    data:sendData,//что отправили
  }
};

export default {
	name: "pdlLoan",
	data() {
		return {
      isDataReady: false,
      /**
       * screenArrName названия экранов формы, названия не менять!!!!
       */
			screenArrName:['fio' ,'smsConfirm' , 'passport' , 'workInfo', 'payment', 'signingLoan'],
      /**
       * sysScreenArrName системные названия экранов формы, названия не менять!!!!
       */
      sysScreenArrName:['thankYouPage', 'rejection','waiting','fullFail','verificationAwaiting'],
      loanInstReject:false,
      loanPDLReject:false,
			currentScreen:'fio',
			ConfirmationGUID: null,
      checksState:{
        GetAddressTerritory:[],
        GetAddressTerritoryAwaitList:[],
        clientCheck:[],
        clientCheckAwaitList:[],
      },
      /**
       * screenIfPdlTry string экран который покажется пользователю которому не судьба базовый но может попробовать pdl
       */
      screenIfPdlTry:'smsConfirm',
      loadFromEsia: false,
      repeatCl:false,
    }
	},
	components: {
		loader :() => import('@/views/pdlloan/uiLoader'),
		screenFio :() => import('@/views/pdlloan/formScreenFio'),
		screenSmsConfirm :() => import('@/views/pdlloan/formScreenSmsConfirm'),
    screenPassport: () => import('@/views/pdlloan/formScreenPassport'),
    screenWorkInfo: ()=>import('@/views/pdlloan/formScreenWorkInfo'),
		screenPayment:()=>import('@/views/pdlloan/formScreenPaymentSelector'),
    screenSigningLoan:()=>import('@/views/pdlloan/formScreenSigningLoan'),
    screenWaiting:()=>import('@/views/pdlloan/formScreenWaiting'),
    screenThankYouPage: ()=>import('@/views/pdlloan/formScreenTYpage'),
    screenRejection: ()=>import('@/views/pdlloan/formScreenRejection'),
    screenVerificatorAwaiting: ()=>import('@/views/pdlloan/formScreenVerificatorAwaiting'),
    screenFullFail: ()=>import('@/views/pdlloan/formScreenFullFail'),
    uiProductAmountSelector: ()=>import('@/views/pdlloan/uiProductAmountSelector'),
    uiHead: ()=>import('@/views/pdlloan/uiHead'),
    uiTitle: ()=>import('@/views/pdlloan/uiTitle'),
    uiHowTo: ()=>import('@/views/pdlloan/uiHowTo'),
    uiPreim: ()=>import('@/views/pdlloan/uiPreim'),
    uiUslovia: ()=>import('@/views/pdlloan/uiUslovia'),
    // uiContacts: ()=>import('@/views/pdlloan/uiContacts'),
    uiContactsWhite: ()=>import('@/views/pdlloan/uiContactsWhite'),
    sceenCathError:()=>import('@/views/pdlloan/formScreenCathError')
	},
	computed:{
		...mapState({
      pdlSelectedAmount:state=>state.Deal.pdlSelectedAmount,
			statusVuex      : state => state.Form.workData,
			valueVuex       : state => state.Form.sendData,
			isLoading       : state => state.Form.system.loading,

      pdlDeal: state=> state.Deal.pdlDeal,
      availablePeriods: state=> state.Deal.pdlPeriods,
      system: state=> state.Form.system,
      limitValue: state => state.Form.deal.limitValue
		}),
		...mapGetters([   'isAdressValid', 'getRedirectUrl','getSelectedDeal','getActiveMinDeal','getActiveMaxDeal']),
    /**
     * возвращает номер текущего экрана
     * @return int
     */
		currentScreenNumber(){
			return this.screenArrName.indexOf(this.currentScreen) + 1;
		},
    /**
     * вернет массив обхекто уникальных сумм
     * @returns array
     */
    availableSumKostilFormat(){
      let distinctSumm = [];
      let out = [];
      for (let i = 0; i < this.pdlDeal.length; i+=1){
        if (distinctSumm.indexOf(this.pdlDeal[i].Amount) <0 ){
          distinctSumm.push(this.pdlDeal[i].Amount);
        }
      }
      let tmp = distinctSumm.sort(function(a, b) {
        return a - b;
      });
      if (tmp.length >0) {
        for (let i = 0; i < tmp.length; i+=1){
          out.push({value: tmp[i], name: tmp[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")});
        }
      }
      return out;
    },
    /**
     * вернет массив обхектов уникальных периодов
     * @returns array
     */
    // availablePeriodsKostilFormat(){
    //   let out = [];
    //   for (let i = 0; i < this.availablePeriods.length; i+=1){
    //     out.push({value: this.availablePeriods[i], name: this.availablePeriods[i] < 52
    //         ?  this.availablePeriods[i] + ' дней'
    //         : this.availablePeriods[i] + ' недели'});
    //   }
    //   return out;
    // },
    phoneForProduct(){
      return {
        href:this.getSelectedDeal.vwIsPdl === '0' ? '88006009990' :'88006000685',
        view:this.getSelectedDeal.vwIsPdl === '0' ? '8 800 600 99 90' :'8 800 600 06 85'
      }
    }
	},
  watch:{
    currentScreen: async function (newValue,oldValue) {
      // !!!!!не забудь закомментировать перед пушем!!!!!
      // if(process.env.NODE_ENV === 'development') {
      //   /* eslint-disable no-unreachable */
      //   return ;
      // }


      await tracing.sendTrace();

      let sendData = {
        action: 166,
        session_id: window.session_id,
        token:window.token,
        new:newValue,
        old:oldValue,

      };

      if(oldValue==='smsConfirm' && newValue==='passport' && localStorage.getItem('ConfirmationGUID') !== null) {
        sendData.ConfirmationGUID = localStorage.getItem('ConfirmationGUID');

      }
      if(oldValue==='passport') {
        //запускаем кракена, на поиск лимита
        this.findLimit();
      }


      //todo this.valueVuex.CALC_WEEK !== 52 бомба отложенного действия, пока не появится новый продукт
      if(newValue === 'waiting' && this.getSelectedDeal.vwIsPdl === '1') {
        sendData.SendToken = localStorage.getItem('smsGuid');
      }

          if (isNaN(parseInt(localStorage.getItem('cid'),10))) {
            sendData.ClientId = 0;
          } else {
            sendData.ClientId = parseInt(localStorage.getItem('cid'),10);
          }

          if (localStorage.getItem('TraceIdWebix') !== null) {
            sendData.TraceIdWebix = localStorage.getItem('TraceIdWebix');
          }


      try {
        const res = await this.$axios.post(process.env.VUE_APP_URL_TRACE, sendData);
        if (!res?.data?.result) {
          throw new Error('result undefined')
        }
        if (res.data.errorCode !== 0) {
          throw new Error('errorCode !== 0')
        }

        this.fillLocalStorage(res.data.result);
        if (res.data.result.loan?.DemandId) {
          tracing.traceInput({
            action:165,
            refs:'DemandId',
            value:res.data.result.loan.DemandId
          });
        }

        if (!res.data.result.loan?.ClientId) {
          throw new Error('res.data.result.loan.ClientId undefined');
        }
      } catch(e) {
        console.log(e);
        this.currentScreen = 'cathError';
      }

      // // eslint-disable-next-line no-unused-vars
      // if(window.ym && this.screenArrName.indexOf(oldValue)){
      //   // eslint-disable-next-line no-undef
      //   ym(51632228,'reachGoal',oldValue);
      // }

      try {
        this.$external.traceInput({
          action:165,
          refs:'score_juicyscore_sessionId_errorMsg',
          value:'run window.juicyScoreApi.getSessionId()'
        });
        window.juicyScoreApi.getSessionId().then((sessionId) => {
          this.$external.traceInput({
            action:165,
            refs:'score_juicyscore_sessionId',
            value:sessionId
          });
        });
      } catch (e) {
        this.$external.traceInput({
          action:165,
          refs:'score_juicyscore_sessionId',
          value:null
        });
        this.$external.traceInput({
          action:165,
          refs:'score_juicyscore_sessionId_errorMsg',
          value:e.toString()
        });
        if (window.juicyScoreApi !== undefined) {
          this.$external.traceInput({
            action:165,
            refs:'score_juicyscore_sessionId_errorMsg',
            value:JSON.stringify(window.juicyScoreApi.apiEvents)
          });
        } else {
          this.$external.traceInput({
            action:165,
            refs:'score_juicyscore_sessionId_errorMsg',
            value:'window.juicyScoreApi undefined'
          });
        }
      }

    },
    'valueVuex.FIRST_NAME':function () {this.checkDataForRunClientCheck()},
    'valueVuex.LAST_NAME':function () {this.checkDataForRunClientCheck()},
    'valueVuex.SECOND_NAME':function () {this.checkDataForRunClientCheck()},
    'valueVuex.PHONE':function () {this.checkDataForRunClientCheck()},
    'valueVuex.RESIDENTIAL_ADDRESS':function () {
      // console.log(newValue)
      //если спалили что адрес получил данные то пришло наше время
      const checkAddress = this.isAdressValid('RESIDENTIAL_ADDRESS',false);
      //проверяем что адрес проходит валидацию(точность адреса до указанного дома
      if (checkAddress.length > 0) {
        //есть некие косяки, поэтому подсвечиваем пользователю что нужно добавить
        this.$store.dispatch('fieldError', {target: 'RESIDENTIAL_ADDRESS', value: checkAddress});
      } else {
        //запуск проверки
        this.launchInstanceCheck({
          action:'GetAddressTerritory',
          Address:this.valueVuex.RESIDENTIAL_ADDRESS,
          RESIDENTIAL_ADDRESS_DADATA:this.valueVuex.RESIDENTIAL_ADDRESS_DADATA,
          PartnerID: this.system.Partner_Id.toString()
        },'clientCheck');
      }

      this.$external.traceInput({
        action:165,
        refs:'RESIDENTIAL_ADDRESS',
        value:this.valueVuex.RESIDENTIAL_ADDRESS
      });
      this.$external.traceInput({
        action:165,
        refs:'RESIDENTIAL_ADDRESS_DADATA',
        value:this.valueVuex.RESIDENTIAL_ADDRESS_DADATA
      });
    },
    'valueVuex.REGISTRATION_ADDRESS':function(){
      this.$external.traceInput({
        action:165,
        refs:'REGISTRATION_ADDRESS',
        value:this.valueVuex.REGISTRATION_ADDRESS
      });
      this.$external.traceInput({
        action:165,
        refs:'REGISTRATION_ADDRESS_DADATA',
        value:this.valueVuex.REGISTRATION_ADDRESS_DADATA
      });
    },
    'valueVuex.WORK_JOB':function(){
      this.$external.traceInput({
        action:165,
        refs:'WORK_JOB',
        value:this.valueVuex.WORK_JOB
      });
      this.$external.traceInput({
        action:165,
        refs:'WORK_JOB_DADATA',
        value:this.valueVuex.WORK_JOB_DADATA
      });
    },
    'valueVuex.WORK_TITLE':function() {
      this.$external.traceInput({
        action: 165,
        refs: 'WORK_TITLE',
        value: this.valueVuex.WORK_JOB
      });
    },
    'valueVuex.WORK_TITLE_GIG_DATA':function (){
      this.$external.traceInput({
        action:165,
        refs:'WORK_TITLE_GIG_DATA',
        value:this.valueVuex.WORK_TITLE_GIG_DATA
      });
    },
    'valueVuex.CALC_SUMM':function () {
      this.$external.traceInput({
        action:165,
        refs:'CALC_SUMM',
        value:this.valueVuex.CALC_SUMM
      });
      localStorage.setItem('CALC_SUMM',this.valueVuex.CALC_SUMM);
    },
    'valueVuex.CALC_WEEK':function () {
      this.$external.traceInput({
        action:165,
        refs:'CALC_WEEK',
        value:this.valueVuex.CALC_WEEK
      });
      localStorage.setItem('CALC_WEEK',this.valueVuex.CALC_WEEK);
    },
    getSelectedDeal:function (newValue) {
      this.$external.traceInput({
        action:165,
        refs:'pdlGetSelectedDeal',
        value:newValue
      });
    }
  },
	methods:{
    findLimit(){
      setTimeout(()=>{
        if(parseInt(localStorage.getItem('DemandId'),10) > 0) {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_API_MS+'/checkLimit.php',
            data: {
              demandId: parseInt(localStorage.getItem('DemandId'),10),
              token: window.token,
              session_id:window.session_id
            }
          }).then((res) => {
            console.log(res)
            if(res.data.Error.Code === 0) {
              if(res.data.Data.Status === 'DONE' && parseInt(res.data.Data.FinalLimit,10) > 0) {
                this.$store.dispatch('setLimit',parseInt(res.data.Data.FinalLimit,10))
              }else{
                this.findLimit();
              }
            }
          }).catch((res)=>{
            console.log(res)
          });
        } else {
          this.findLimit();
        }
      }, 2000);
    },
    pushValuesToForm(arrValues,listFormFields){
      for(let i=0; i < listFormFields.length;i+=1) {
        try {
          if(arrValues[listFormFields[i]] !== undefined
            && arrValues[listFormFields[i]] !== null
            && arrValues[listFormFields[i]] !== ''){
            //ставим признак повторника, так себе, но есть причины
            this.repeatCl = true;
            this.$store.dispatch('saveSendData',{
              target:listFormFields[i],
              value: listFormFields[i].indexOf('_DADATA') >= 0 ?
                JSON.parse(arrValues[listFormFields[i]]) : arrValues[listFormFields[i]]
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    setPassportValues(data){



      let fields = [
        'BIRTHPLACE',
        'WORK_JOB',
        'EXPER_RADIO',
        'CREDHISTORY_RADIO',
        'CONST_INCOME',
        'OTHER_SOURCES_OF_INCOME',
      ]
      if(!this.loadFromEsia) {
        //если был контакт с гос услугами, то эти поля игнорим, нет оснований не доверять гос услугам!
        fields = fields.concat([
          'PASSPORT_DEP',
          'PASSPORT_DATE',
          'PASSPORT_NUMBER',
          'PASSPORT_SERIES',
          'PASSPORT_DEP_CODE',
          'RESIDENTIAL_ADDRESS_DADATA',
          'RESIDENTIAL_ADDRESS',
          'REGISTRATION_ADDRESS_DADATA',
          'REGISTRATION_ADDRESS',
          // 'IS_ADDRESS_COINCIDES', сломает форму
          'BIRTHDAY',
          'SNILS',
          'SOURCE_OF_INCOME',
          'EDUCATION',
          'MARITAL_STATUS',
          'MINOR_CHILDREN'
        ])
      }
      this.pushValuesToForm(data, fields);

      try {
        let extendedObj = JSON.parse(data['OTHER_JSON_DATA']);
          if(extendedObj?.extended != undefined) {
             this.pushValuesToForm(extendedObj.extended,[
              'EDUCATION',
              'CONTACT_PHONE',
              'MARITAL_STATUS',
              'MINOR_CHILDREN',
              'WORK_JOB_PHONE',
              'SOURCE_OF_INCOME',
              'FINANCIAL_POSITION',
              'PURPOSE_OF_THE_LOAN',
              'AVERAGE_EXPENSES_PER_MONTH',
               'SNILS'
            ]);
          }
       } catch (e) {
          console.log(e)
       }
    },
    setParamsDataFromUrl() {
      // /pdl?first_name=%D1%82%D0%B5%D1%81%D1%82&last_name=%D1%82%D0%B5%D1%81%D1%82&patronymic=%D1%82%D0%B5%D1%81%D1%82&phone=9032073848
      try {
        let fieldMapping = {
          'first_name': 'FIRST_NAME',
          'patronymic': 'SECOND_NAME',
          'last_name': 'LAST_NAME',
          'phone': 'PHONE',
          'email': 'EMAIL',
          'birthday': 'BIRTHDAY',
        };
        let mappedParams = {};

        for (let field in fieldMapping) {
          if (this.$route.query[field] !== undefined) {
            mappedParams[fieldMapping[field]] = this.$route.query[field];
          }
        }

        this.$store.dispatch('setParamsDataUrl', mappedParams);
      } catch (err) {
        console.log('Set params for input', err);
      }
    },
    toPdl(){
      if(this.limitValue > 0) {
          this.$store.dispatch('setLimit',this.limitValue).then(()=>{
            this.currentScreen = this.screenIfPdlTry;
          });
      } else {
        this.$store.dispatch('dealOnlyPdl');
        this.currentScreen = this.screenIfPdlTry;
      }

    },
    validatorArrField(arrChekedField, showError = true) {
      this.$external.consoleDebug('validatorArrField','open');
      this.$external.consoleDebug({arrChekedField});
      let result = true;
      arrChekedField.forEach(item => {
        this.$external.consoleDebug({item});
        if (this.statusVuex[item].code !== 0) {
          if (showError) {
            this.$store.dispatch('errorShow', {target: item, value: true,});
          }
          result = false;
        }
        this.$external.consoleDebug({result});
      });
      this.$external.consoleDebug('validatorArrField','close');
      return result;
    },
		validatorFio() {
      let fields = [
        'PHONE',
        'EMAIL',
        // 'RESIDENTIAL_ADDRESS',
        'SECOND_NAME',
        'LAST_NAME',
        // 'BIRTHDAY',
        'FIRST_NAME',
        // 'GENDER'
      ];
			let result = this.validatorArrField(fields);
      // const checkAddress = this.isAdressValid('RESIDENTIAL_ADDRESS');
      // if (checkAddress.length > 0) {
      //   this.$store.dispatch('fieldError', {target: 'RESIDENTIAL_ADDRESS', value: checkAddress});
      //   // this.$palantir.trackAction(116, 'RESIDENTIAL_ADDRESS');
      //   result = false;
      // }
      this.clickSaveData(fields);
			return result;
		},
    validatorPassport(){
      console.log('validatorPassport')
      let fields= [
        'PASSPORT_SERIES',
        'PASSPORT_NUMBER',
        'PASSPORT_DEP_CODE',
        'PASSPORT_DATE',
        'BIRTHPLACE',
        'REGISTRATION_ADDRESS',
        'RESIDENTIAL_ADDRESS',
        'PASSPORT_DEP',
        'SNILS',
        'BIRTHDAY',
        'GENDER'
      ];
      let result = this.validatorArrField(fields);
      let checkAdress = this.isAdressValid('REGISTRATION_ADDRESS');
      if (checkAdress.length > 0) {
        this.$store.dispatch('fieldError', { target: 'REGISTRATION_ADDRESS', value: checkAdress });
        result =  false;
        this.$palantir.trackAction(116,'REGISTRATION_ADDRESS');
      }
      let checkAddress = this.isAdressValid('RESIDENTIAL_ADDRESS');
      if (checkAddress.length > 0) {
        this.$store.dispatch('fieldError', {target: 'RESIDENTIAL_ADDRESS', value: checkAddress});
        // this.$palantir.trackAction(116, 'RESIDENTIAL_ADDRESS');
        result = false;
      }


      if(!this.loadFromEsia || !this.repeatCl){
        if(this.valueVuex['smartIdFileID'] === 0){
          this.$store.dispatch('errorShow', {
            target: 'smartIdFileID',
            value: true,
          });
          result = false;
        }
      }

      this.clickSaveData(fields);
      return result;
    },
    runSmsConfirmCheck(){
      return new Promise((resolve, reject) => {
        this.$store.dispatch('showLoading');
				this.$external.run({
					action: 'SMSConfirmationCodeCheck',
					ConfirmationGUID: localStorage.getItem('ConfirmationGUID'),
					ConfirmationCode: this.valueVuex['SmsConfCode'],
				}).then((res)=>{
					let resOb = res;
						if (resOb.ExecutionResult !== undefined) {
							if (resOb.ExecutionResult.CheckResult !== undefined) {
								if (resOb.ExecutionResult.CheckResult === true) {
                  //тут вставка, если заявка на верификации ни каких займов пдл, пока верификатор кнопку не жмякнет
                  let nextScreenName = 'passport';
                  console.log('resOb.ExecutionResult.Already_verif',resOb.ExecutionResult.Already_verif)
                  try {
                    if (resOb.ExecutionResult.Already_verif !== undefined && this.getSelectedDeal.vwIsPdl === '1') {
                      if(parseInt(resOb.ExecutionResult.Already_verif,10) > 0) {
                        nextScreenName = 'verificationAwaiting';
                      }
                    }
                  } catch (e){
                    console.log('try verificationAwaiting');
                  }
                  console.log('nextScreenName',nextScreenName)
									resolve(nextScreenName);
								} else {
									reject({
										ExecutionErrorCode: 2,
										ExecutionErrorMessage: 'Некорректный	код'
									});
								}
							}
						}
				}).catch((res)=>{
					if (res.ExecutionErrorCode !== undefined) {
            reject(res);
          } else {
            reject({
              ExecutionErrorCode: 3,
              ExecutionErrorMessage: 'Ошибка проверки кода sid=' + window.session_id
            });
          }
				}).finally(()=>{
					this.$store.dispatch('hideLoading');
        });

      });
    },
    pdlConfirmCodeCheck(){
      return new Promise(((resolve, reject) => {
        this.$external.consoleDebug('pdlConfirmCodeCheck','open');
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TRACE,
          data: {
            action: 169,
            session_id: window.session_id,
            token: window.token,
            cid: parseInt(localStorage.getItem('cid'), 10),
            smsGuid:localStorage.getItem('smsGuid'),
            code:this.valueVuex['pdlSmsConfCode'],
            traceId:localStorage.getItem('traceId'),
          }
        }).then((res)=>{
          if (res.data !== undefined) {
            if (res.data.result !== undefined){
              if (res.data.result.Data !== undefined) {
                if (res.data.result.Data) {
                  resolve();
                } else {
                  reject();
                }
              }
            } else {
              reject();
            }
          } else {
            reject();
          }
        }).catch((res)=>{
          this.$external.consoleDebug(res);
          reject()
        }).finally(()=>{
          this.$external.consoleDebug('pdlConfirmCodeCheck','close');
        })
      }));
    },
    checkDataForRunClientCheck(){
      this.$external.consoleDebug('checkDataForRunClientCheck','open');
        const allFieldsReady = this.validatorArrField(['FIRST_NAME','LAST_NAME','SECOND_NAME','PHONE'], false);
        this.$external.consoleDebug({allFieldsReady});
        if (allFieldsReady) {
          this.launchInstanceClientEasyCheck();
        }
      this.$external.consoleDebug('checkDataForRunClientCheck','close');
    },
    timeOutInstanceCheck(action){
      this.$external.consoleDebug('timeOutInstanceCheck','open');
      const timeDelay = 3000;
      const currentIndex = this.checksState[action].length - 1;
      const currentObject = this.checksState[action][currentIndex];
      this.$external.consoleDebug({currentObject,currentIndex,action});
      if (currentObject.status < 0) {
       //текущая проверка еще не запущенна есть вариант, попробовать стартануть, при ином статусе проверка уже работает
        let timeNow = new Date().getTime();
        if ((timeNow - currentObject.stTime) > timeDelay) {
          currentObject.status = 0;
          this.$external.consoleDebug('external run');
            this.$external.run(currentObject.data).then(res=>{
              this.$external.consoleDebug('external run then');
              currentObject.result = res;
            }).catch(res=>{
              this.$external.consoleDebug('external run catch');
              currentObject.result = res;
              currentObject.error = 1;
            }).finally(()=>{
              this.$external.consoleDebug('external run finally');
              currentObject.endTime = new Date().getTime();
              currentObject.status = 1;
            });
        } else {
          this.$external.consoleDebug('timeOut');
          setTimeout(()=>{
            this.timeOutInstanceCheck(action);
          }, timeDelay);
        }
      }
      this.$external.consoleDebug('timeOutInstanceCheck','close');
    },
    launchInstanceCheck(sendData){
      this.$external.consoleDebug('launchInstanceCheck','open');
      const linkToState = Object.assign(this.checksState[sendData.action],[]);
      const objForWork = awaitObjectTemplate(sendData);

      if (linkToState.length === 0 || linkToState[linkToState.length - 1].status >= 0) {
        this.$external.consoleDebug('psuh');
        //если проверка еще не запускалась, или уже выполена или работает, то добавляем новую проверку в список
        linkToState.push(objForWork);
      } else {
        //иначе уже сужешствующую отменяем перезаписью новой
        this.$external.consoleDebug('update');
        linkToState[linkToState.length - 1] =  awaitObjectTemplate(sendData);
      }

      this.timeOutInstanceCheck(sendData.action);
      this.$external.consoleDebug('launchInstanceCheck','close');

    },
    launchInstanceClientEasyCheck(){
      this.launchInstanceCheck({
        action:'clientCheck',
        FirstName:this.valueVuex.FIRST_NAME,
        LastName:this.valueVuex.LAST_NAME,
        MiddleName:this.valueVuex.SECOND_NAME,
        Phone:this.valueVuex.PHONE,
        PartnerID: this.system.Partner_Id.toString()
      });
    },
    howClientWasChecked(arrCheckTypeRequired=[],awaitResult = false){


      return new Promise((resolve, reject) => {
        this.$external.consoleDebug('howClientWasChecked','open');
        const currentCheckState = this.checksState;
        let result = 0; //счетчик проверок, 0 все хорошо, > 0 клиент не подходит по проверке
        let i = 0;
        while(i < arrCheckTypeRequired.length){
          this.$external.consoleDebug('for i='+i,'open');
          this.$external.consoleDebug(currentCheckState[arrCheckTypeRequired[i]]);

          if (currentCheckState[arrCheckTypeRequired[i]] !== undefined) {
            let executeInstance = currentCheckState[arrCheckTypeRequired[i]];
            let lastExecuteInstance = executeInstance[executeInstance.length - 1];
            this.$external.consoleDebug({lastExecuteInstance,executeInstance});
            if (lastExecuteInstance.status === 0) {
              //если проверка сейчас работает
              if (awaitResult) {
                //и нужно дождаться когда она закончит работу, то запускаем себя же в рекурсии
                setTimeout(()=>{
                  this.howClientWasChecked(arrCheckTypeRequired,awaitResult).then(()=>resolve()).catch(()=>reject());
                }, 300);
              } else {
                //иначе выползаем из цикла, с псевдо ответом что все хорошо
                result = 0;
                i = arrCheckTypeRequired.length;
              }
            } else {
              //если проверка закончила работу, палим ошибки и нарашиваем счетчик косяков
              try {
                //ошибки выполнения скрипта или штатные коды отказа заведения заявки
                if (lastExecuteInstance.error > 0 || lastExecuteInstance.result.ExecutionError.ExecutionErrorCode !==
                  0) {
                  result += 1;
                }
              } catch (e) {
                  result += 1;
              }
            }
          }

          this.$external.consoleDebug('for i='+i,'close');
          i += 1;
        }
        if (result === 0) {
          resolve();
        } else {
          reject();
        }
        this.$external.consoleDebug('howClientWasChecked','close');
      })
    },
    clickSaveData(fields){
      let valuesFields = {};
      fields.forEach((key)=>{
        valuesFields[key] = this.valueVuex[key];
      });
      this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TRACE,
          data: {
            action:170,
            token: window.token,
            session_id:  window.session_id,
            valuesFields: valuesFields
          }
      }).then((res)=>{
        console.log(res);
      }).catch(res=>{
        console.log(res);
      });
    },
		nextBlock() {
      let checkInputs;
			switch(this.currentScreen){
				case 'fio':
          if(this.validatorFio()) {
            // if(this.valueVuex.CALC_WEEK === 52) {
            //   this.howClientWasChecked(['GetAddressTerritory', 'clientCheck'])
            //   .then(() => {
            //     this.currentScreen = 'smsConfirm';
            //   }).catch(() => {
            //     this.screenIfPdlTry = 'smsConfirm';
            //     this.currentScreen = 'rejection';
            //   });
            // } else {
              this.currentScreen = 'smsConfirm';
            // }
					} else {
            this.WsScrollTo({id:'zform'});
          }
					break;
        case 'smsConfirm':
          if(this.validatorArrField(['SmsConfCode','ASP','AGREEMENT_KI_REQUEST'])) {
            this.runSmsConfirmCheck()
              .then((nextScreen)=>{
                this.currentScreen = this.screenIfPdlTry =  nextScreen;
              }).catch((res)=>{
                if(res.ExecutionErrorCode === 2) {
                  this.$store.dispatch('fieldError', {
                    target: 'SmsConfCode',
                    value: 'Некорректный	код'
                  });
                } else {
                  this.$store.dispatch('fieldError', {
                    target: 'SmsConfCode',
                    value: 'Не удалось проверить код, попробуйте позже. sid=' + window.session_id,
                  });
                }
            });
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
        case 'passport':
          if (this.validatorPassport()){
            if (this.getSelectedDeal.vwIsPdl === '0') {
              this.howClientWasChecked(['GetAddressTerritory', 'clientCheck'])
              .then(() => {
                this.currentScreen = this.screenIfPdlTry = 'workInfo';
              }).catch(() => {
                this.screenIfPdlTry = 'workInfo';
                this.currentScreen = 'rejection';
              });
            } else {
              this.currentScreen = 'workInfo';
            }
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
        case 'workInfo':
          checkInputs = ['WORK_JOB',
            'EXPER_RADIO',
            'CONST_INCOME',
            'EDUCATION',
            'MARITAL_STATUS',
            'MINOR_CHILDREN',
            'SOURCE_OF_INCOME',
            'PURPOSE_OF_THE_LOAN',
            'FINANCIAL_POSITION',
            'MY_OWN_BENEFIT',
            'ACTIONS_CONTROL',
            'NOT_RELATED',
          ];

          if (this.getSelectedDeal.vwIsPdl === '0') {
            checkInputs.push('MEETING_DATE');
            checkInputs.push('MEETING_HOUR');
          }

          if (this.validatorArrField(checkInputs)){
            if (this.getSelectedDeal.vwIsPdl === '0') {
              this.howClientWasChecked(['GetAddressTerritory', 'clientCheck'])
              .then(() => {
                this.currentScreen = 'waiting';
                this.screenIfPdlTry = 'payment';
              }).catch(() => {
                this.screenIfPdlTry = 'payment';
                this.currentScreen = 'rejection';
              });
            } else {
              // if(this.valueVuex['CALC_SUMM'] > 10000) {
              //   let newConstIncotme = parseInt(this.valueVuex['CONST_INCOME'], 10) * 3;
              //   newConstIncotme = newConstIncotme <= 150000 ? newConstIncotme : 150000;
              //   this.$store.dispatch('saveSendData',{
              //     target:'CONST_INCOME',
              //     value: newConstIncotme
              //   });
              //   this.$external.traceInput({
              //     action:165,
              //     refs:'CONST_INCOME',
              //     value: newConstIncotme
              //   });
              // }
              this.$store.dispatch('dealOnlyPdl');
              this.currentScreen = 'payment';
            }
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
				case 'payment':

					if ( (this.valueVuex.PAYMENT_TYPE === 'TinkoffE2C' && this.valueVuex.tinkoffE2C_cardSelected.cardId !==
            undefined) ||
              (this.valueVuex.PAYMENT_TYPE === 'TinkoffA2C' && this.valueVuex.tinkoffA2C_bankSelected.memberName !==
                undefined) ) {
            this.currentScreen = 'signingLoan';
					}else {
            alert('Для перехода далее необходимо выбрать карту или банк для начисления денежных средств');
            this.WsScrollTo({id:'zform'});
					}
					break;
        case 'signingLoan':
           checkInputs = [
            'THIRD_PARTIES',
            'ACCEPTANCE_OF_THE_TERMS',
            'AGREEMENT_WITH_THE_RULES',
            'AGREEMENT_KI_REQUEST',
            'GENERAL_TERMS_OF_MICROLOAN',
            'RULES_FOR_MICROLOAN',
            'APPLICATION_MICROLOAN',
            'AGREEMENT_IU',
            'REQURENT_PAY',
            'pdlSmsConfCode'
          ];
          if(this.validatorArrField(checkInputs)) {
            this.pdlConfirmCodeCheck()
              .then(()=>{
                // // eslint-disable-next-line no-unused-vars
                // if (window.ym) {
                //   // eslint-disable-next-line no-undef
                //   ym(51632228,'reachGoal','pdlLoan') ;
                // }
                this.currentScreen = 'waiting';
              })
              .catch(()=>{
                this.$store.dispatch('fieldError', {
                  target: 'pdlSmsConfCode',
                  value: 'Некорректный	код'
                });
              });
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
        case 'waiting':

          break;
        case 'thankYouPage':
          break;
        case 'rejection':
          break;
				default:
					alert('Ошибка в форме попытка переключения на экран ' +  this.currentScreen);
					break;
			}
		},
		WsScrollTo(obj, $event = false) {

      if (obj.event !== undefined && obj.event !== false) {
        obj.event.preventDefault();
      }
      if ($event !== false) {
        $event.preventDefault();
      }
      document.getElementById(obj.id).scrollIntoView({
        behavior: 'smooth',
      });
		},
    loadFromAnkets() {
      this.$external.consoleDebug('loadFromAnkets','open');
      let self = JSON.parse(localStorage.getItem('lcObject'));
      this.$external.consoleDebug(self);
      this.$external.consoleDebug('loadFromAnkets','close');
    },
    addChat(){
      let s;
      s = document.createElement('script');
      s.src = '//code.jivo.ru/widget/HlZ14RdVxQ';
      document.head.appendChild(s);
    },
    async sendTrace() {
      // условие, что для 165 экшена время с последнего вызова больше 3 сек
      const last = tracing.getLastTrace();
      if(last && last.action === 165 && Date.now() - last.ts_end < 3000) {
        setTimeout(async () => await this.sendTrace(), Date.now() - last.ts_end);
      } else {
        await tracing.sendTrace();
        setTimeout(async () => await this.sendTrace(), 3000);
      }
    },
    fillLocalStorage({sms, TraceId, loan}) {
      if (sms?.Data) {
        localStorage.setItem('smsGuid', sms.Data);
      }
      if (TraceId) {
        localStorage.setItem('traceId', TraceId);
      }
      if (loan) {

        if (loan.ClientId) {
          localStorage.setItem('cid', loan.ClientId);
        }
        if (loan.DemandId) {
          localStorage.setItem('DemandId', loan.DemandId);
        }
        if (loan.TaskScoring) {
          localStorage.setItem('TaskScoring',loan.TaskScoring);
        }
        if (loan.TraceId) {
          localStorage.setItem('TraceIdWebix',loan.TraceId);
        }
        if (loan.Data) {
          this.setPassportValues(loan.Data);
        }
        // if (loan.IsNewClient) {
        //   // акция для новых клиентов н
        //   this.$store.commit('setSaleForVirgin')
        // }
      }
    },
    async getEsiaToken(code) {
      const params = {
        grant_type: 'authorization_code',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        client_id: process.env.VUE_APP_ID_ESIA,
        code,
        client_secret: process.env.VUE_APP_SECRET_ESIA
      }
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/token, ${JSON.stringify(params)}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/token`, { ...params })
        this.$palantir.trackAction(177, `fromESIA - getEsiaToken - ${JSON.stringify(data)}`);
        return data.access_token
      } catch(e) {
        console.log(e)
      }
    },
    async getCpg(access_token) {
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/userinfo, ${JSON.stringify({ headers: { 'Authorization': 'Bearer ' + access_token} })}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/userinfo `, {}, { headers: { 'Authorization': 'Bearer ' + access_token} })
        this.$palantir.trackAction(177, `fromESIA - getCpg - ${JSON.stringify(data)}`);
        return data.info
      } catch(e) {
        console.log(e)
      }
    },
    async saveDadataAddress(refs) {
      const { data } = await this.$myApi.suggestResult(
        refs,
        { 'value': this.valueVuex[refs], 'type': refs })
      if(data.result.suggestions.length > 0) {
        this.$store.dispatch('saveSendData', {
          target: refs + '_DADATA',
          value: data.result.suggestions[0],
        });
        this.$store.dispatch('saveSendData', {
          target: refs,
          value: data.result.suggestions[0].value
        });
      } else {
        this.$palantir.trackAction(176, this.valueVuex[refs]);
      }
    },
    activityEsiaProductRecoveryCheckOlds(target){
      if(localStorage.getItem(target) !== null) {
        localStorage.setItem('pre'+target,localStorage.getItem(target));
      }
    },
    activityEsiaProductRecoverySet(target){
      if(localStorage.getItem('pre'+target) !== null){
        const value = parseInt(localStorage.getItem('pre'+target),10);
        if(value > 0) {
          this.$store.dispatch('saveSendData', {
            target: target,
            value: value
          });
        }
      }
    },
    activityEsiaProductRecovery(){
      //для особых хотелок, если до авторизации на госуслугах, трогали сумму, то эту сумму подставляем в эту сессию
      //с оттяжекой, что бы вся херня успела прогрузиться и пропихнуться
      setTimeout(()=>{
        this.activityEsiaProductRecoverySet('CALC_SUMM');
        this.activityEsiaProductRecoverySet('CALC_WEEK');
      },666);
    },
    activityEsia(){
      //маркер пользователь потрогал, гос услуги
      this.$external.traceInput({
        action:165,
        refs:'activityEsia',
        value: true
      });
      this.activityEsiaProductRecovery();
    },
    getFromNsk(){
      const nskAlias = [
        {nsk:'lastName', msk:'LAST_NAME'},
        {nsk:'firstName', msk:'FIRST_NAME'},
        {nsk:'middleName', msk:'SECOND_NAME'},
        {nsk:'phone', msk:'PHONE'},
        {nsk:'email', msk:'EMAIL'},
        {nsk:'passportSerie', msk:'PASSPORT_SERIES'},
        {nsk:'passportNumber', msk:'PASSPORT_NUMBER'},
        {nsk:'passportIssueDate', msk:'PASSPORT_DATE'},
        {nsk:'birthPlace', msk:'BIRTHPLACE'},
        {nsk:'birthPlace', msk:'BIRTHPLACE'},
        {nsk:'orgName', msk:'WORK_JOB'},
        {nsk:'orgPosition', msk:'WORK_TITLE'}
        // {nsk:'address', msk:'WORK_TITLE'}
      ];

      try {
        if(this.$route.query.subid) {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_API_MS + '/getNskData.php',
            data: {
              token: this.system.token,
              session_id:this.system.session_id,
              guid:this.$route.query.subid
            }
          }).then((res)=>{
            const workData = res?.data?.result?.client;
            if(workData && Object.keys(workData).length > 0 && workData.constructor === Object) {
              nskAlias.forEach((item)=>{
                if(workData[item.nsk] !== undefined && workData[item.nsk] != null){
                  this.$store.dispatch('saveSendData',{
                    target:item.msk,
                    value:workData[item.nsk]
                  })
                }
              });
            }
            if(this.$route.query.sub1 && parseInt(this.$route.query.sub1,10) > 0 && this.$route.query.sub1 % 1000 === 0){
              const addCalcSumm = parseInt(this.$route.query.sub1,10);
              if (addCalcSumm >= this.getActiveMinDeal && addCalcSumm <= this.getActiveMaxDeal) {
                this.$store.dispatch('saveSendData',{
                  target:'CALC_SUMM',
                  value:addCalcSumm
                })
              }
            }
          }).catch((res)=>{
            console.log(res)
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    importDataFromPartner(){
      switch(this.system.Partner_Id) {
        case 10004:
          this.getFromNsk();
          break;
        case 10006:
          this.getFromNsk();
          break;
        default:
          break;
      }

    },
    // testLimit(){
    //   // this.testLimitCase1(60000,8000);
    //   // this.testLimitCase2(60000,8000);
    //   this.testLimitCase3(7000,8000);
    // },
    // testLimitCase3(_userSumm,_limit){
    //   this.testLimitSetSumm(_userSumm)
    //
    //   .then(this.testLimitSetLimit(_limit))
    //       .then(this.testLimittoSign)
    // },
    // /*
    // сценарий, если оформляли базовый, но пришел отказ и пользователь поперся заполнять пдл, лимит приперся на экране подписания
    //  */
    // testLimitCase2(_userSumm,_limit){
    //   this.testLimitSetSumm(_userSumm)
    //       .then(this.testLimitGotReject)
    //       .then(this.testLimitClickPdl)
    //       .then(this.testLimittoSign)
    //       .then(this.testLimitSetLimit(_limit))
    // },
    // /*
    // сценарий, если оформляли базовый, но пришел отказ и пользователь поперся заполнять пдл, лимит уже есть
    //  */
    // testLimitCase1(_userSumm,_limit){
    //   this.testLimitSetSumm(_userSumm)
    //       .then(this.testLimitSetLimit(_limit))
    //       .then(this.testLimitGotReject)
    //       .then(this.testLimitClickPdl)
    //       .then(this.testLimittoSign)
    // },
    // testLimitSetSumm(_summ){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitSetSumm')
    //     setTimeout(()=>{
    //       this.$store.dispatch('saveSendData', {
    //         target: 'CALC_SUMM',
    //         value: _summ
    //       });
    //       console.log('testLimitSetSumm')
    //       console.groupEnd('testLimitSetSumm')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimitSetLimit(_summ){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitSetLimit')
    //     setTimeout(()=>{
    //       this.$store.dispatch('setLimit',_summ)
    //       console.log('testLimitSetLimit')
    //       console.groupEnd('testLimitSetLimit')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimitGotReject(){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitGotReject')
    //     setTimeout(()=>{
    //       this.currentScreen='rejection';
    //       console.log('testLimitGotReject')
    //       console.groupEnd('testLimitGotReject')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimitClickPdl(){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitClickPdl')
    //     setTimeout(()=>{
    //       this.toPdl();
    //       console.log('testLimitClickPdl')
    //       console.groupEnd('testLimitClickPdl')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimittoSign(){
    //   return new Promise((resolve)=>{
    //     console.group('testLimittoSign')
    //     setTimeout(()=>{
    //       this.currentScreen='signingLoan'
    //       console.log('testLimittoSign')
    //       console.groupEnd('testLimittoSign')
    //       resolve();
    //     },500)
    //   })
    // },
  },
	async mounted(){


    window.juicyLabConfig = {
      nextButton: "your-next-button-id",
      stopPingButton: "your-ping-button-id",
      completeButton: " yoursubmit-button-id",
      // apiKey: "2ioRgFrYfCAuI6ZlQwlpIZgC"
      apiKey: "PvDI6QGMB8WSWEGpkahXHn97"
    };

    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = "https://score.juicyscore.com/static/js.js";
    var x = document.getElementsByTagName('head')[0];
    x.appendChild(s);






    // eslint-disable-next-line no-unused-vars
    if (window.ym){
      // eslint-disable-next-line no-undef
      ym(97209094, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
      // // eslint-disable-next-line no-undef
      // ym(51632228,'reachGoal','enter23');
    }
    this.activityEsiaProductRecoveryCheckOlds('CALC_SUMM');
    this.activityEsiaProductRecoveryCheckOlds('CALC_WEEK');

    localStorage.removeItem('cid');
    // let self = this;
    this.$axios({
      method: 'post',
      url: process.env.VUE_APP_URL_SESSION,
      data: {
        location:document.location.href,
        localStorage:localStorage.getItem('lcObject'),
        token: this.$route.query.state,
        referrer: document.referrer,
      }
    }).then(res=>{
      // Получаем дефолтные параметры для лида. Важные, что пипец
      this.$store.commit('setGuid', res.data.result.guid);
      this.$store.commit('setPartnerId', res.data.result.Partner_Id);
      sessionStorage.setItem('session_id', res.data.result.session_id);
      sessionStorage.setItem('token', res.data.result.token);
      window.session_id = res.data.result.session_id;
      window.token = res.data.result.token;
      window.guid = res.data.result.guid;
      window.Partner_Id = res.data.result.Partner_Id;

      // if(window.Partner_Id === 0){
      //   document.location.href = 'https://lnd.msk.finmoll.com/admd/?Partner_Id=3'
      // }
      //Кто прочитает, и напише нахуа, будет молодец
      if (res.data.result.deal !== undefined){
        this.$store.dispatch('deal23',res.data.result.deal)
      }
      //важные параметры, что бы сохранить в хранилише браузера, пригодится когда открываются новые вкладки, но это не точно
      let lcObject = {
        session_id:  window.session_id,
        guid: this.system.guid,
        utm: res.data.result.utm,
        Partner_Id: this.system.Partner_Id,
        token:  window.token ,
      };
      if (process.env.VUE_APP_FORM_TEST === 'true') {
        lcObject.session_id = 5468868;
        sessionStorage.setItem('session_id', lcObject.session_id);
        lcObject.token = 'CD99B9F2-C0AC-DD65-0177-8DB6FC6C297F';
        sessionStorage.setItem('token', lcObject.token)
      }
      localStorage.setItem('lcObject',JSON.stringify(lcObject));

      //Что-то пошло не так с госуслугами, запишем
      if(this.$route.query.error) {
        this.$palantir.trackAction(175, this.$route.query.error_description);
        this.$router.replace({ query: {} })
      }

      if (this.$route.query.code) {
        this.$palantir.trackAction(177, `fromESIA - ${JSON.stringify(this.$route.fullPath)}`);
        const code = this.$route.query.code;
        this.$router.replace({ query: {} });

        this.getEsiaToken(code).then(access_token => {
          this.getCpg(access_token).then(userInfo => {
            this.activityEsia();
            this.$store.dispatch('saveEsiaInfo', userInfo);
            this.saveDadataAddress('RESIDENTIAL_ADDRESS');
            this.saveDadataAddress('REGISTRATION_ADDRESS');
            this.loadFromEsia = true;
            this.WsScrollTo({id:'zform'});
          })
        })
      }
      this.isDataReady = true;

      this.importDataFromPartner();

    }).catch(res=>{
      console.log(res);

      // document.location.reload();
    });

    this.addChat();
    this.setParamsDataFromUrl();

    setTimeout(async () => await this.sendTrace(), 3000);
    // if(process.env.NODE_ENV == 'development'){
    //   setTimeout(() => this.testLimit(), 3000);
    // }
	},
  created(){
    window.addEventListener('focus',this.loadFromAnkets)
  }
}
</script>
<style>

/*стили для полей*/
.errorMsg { color: red; font-size: 2.87vw; pointer-events: none;position: absolute; background: white;padding: 0 1.60vw; top: 11vw; left: 2.28vw }
.inputBoxWrap { position: relative }
.inputBoxWrap > input{ padding: 4.41vw 5.88vw 4.41vw 5.88vw; margin-bottom: 4.71vw; font-size: 3.47vw; border: 1px
solid #D5D5D5; border-radius: 10px ;width: calc(100% - 11.76vw);}
.inputBoxWrap label { position: absolute; padding: 0 2.67vw ; top: 1px; font-size: 2.87vw; border-top-left-radius: 10px;
  color: #869A95; pointer-events: none; transition: 0.3s ease-out; background: #FFFFFF; left: 2.28vw}
input { display: block; width: 100%;  transition: 0.3s ease-out }
input[type=date] { /* height: 1.5rem; */ }
input:focus ~ label { top: -2vw }
/deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -2vw }
/*остальные стили*/

select,input{background: inherit}

h2 { font-size: 5.29vw }
h3 { color: #222721; font-size: 4.41vw }
p { font-size: 3.53vw }
a { color: #43AC34 }
span { font-size: 2.35vw }
div { font-size: 3.53vw }
label { font-size: 2.94vw }

* { font-family: "Lato-Regular" }
/*.align { margin: unset; width: auto }*/
.alignPDL {  }
button { font-family: 'Lato-Regular'; font-size: 3.53vw }
.fontBold { font-family: 'Lato-Bold' }
#steps { padding: 5.88vw }
#steps > div { margin-bottom: 6.93vw; display: flex; align-items: center; flex-direction: column; }
#steps > div > div { display: flex; align-items: center; margin-bottom: 5.88vw }
#steps > div > div > h3 { }
#steps > div > div > img { margin: 0 4.80vw 0 1.33vw; width: 3.53vw; height: 3.53vw;}
#steps > div > div > label > input { margin: 0 4.80vw 0 1.33vw; width: 5.29vw; height: 5.29vw; border-radius: 5px; background: #f5f5f5; color: #222721 }
#steps > div > div > span { color: rgba(19,21,21,.5019607843137255); font-size: 2.94vw}
#steps > div > div > p { color: rgba(19,21,21,.5019607843137255); font-size: 2.94vw}
#steps > div > div > label:last-child { color: rgba(19,21,21,.5019607843137255)}
#steps > div > div > label > a { color: #43ac34; cursor: pointer }
#steps > div > div > h1 { }
#steps .nextStepBlock { display: flex; align-items: center; flex-direction: row; justify-content: space-between; }
#steps .nextStepBlock > p { display: flex; align-items: center }
#steps .nextStepBlock > button { border-radius: 2.67vw; width: 56vw; padding: 4.27vw; height: 12.27vw}
#zform .sec_2 .pcOnly { display: none }
#screenFormLayout{}
.pcOnly { display: none }
#anketaSteps { padding: 5.88vw ;position: relative}
#screenFormLayout  h2 { margin-bottom: 11.47vw; font-size: 6.47vw }
#zform { }
.mobileOnly { display: block }
.sec_2{position: relative}
div.suggestions span { font-size: 4.41vw }

/*.banner { background-image: url(../../../public/img/fin-moll_banner.svg); font-family: 'Ubuntu-Regular'; padding-top: 4.4vw; color: #FFFFFF; background-size: cover; padding-left: 5.88vw; padding-right: 5.88vw; position: relative }*/
/*.banner svg { width: 40vw }*/
/*.banner .phone { position: absolute; top: 27vw; right: 0 ;pointer-events: none}*/
/*.banner .phone>img { width: 50vw }*/
/*.banner>div>p:first-child { font-size: 4.48vw; font-weight: bold; margin-bottom: 5vw }*/
/*.banner>div>p:nth-child(2) { font-size: 4vw; margin-bottom: 5vw; line-height: 6vw }*/
/*.banner>div>p:nth-child(4) { font-size: 1.6vw; padding-bottom: 5vw; padding-top: 5vw }*/
/*.banner>div>p>span { font-size: 4vw; background-color: #ABE600; color: #0f5740; font-weight: bold }*/
/*.banner a{color:inherit}*/

@media (min-width: 760px) {
  /*стили для полей*/
  .errorMsg { font-size: 0.81vw; top: 2.8vw; left: 0.28vw; }
  .inputBoxWrap > input { padding: 0.89vw 1.61vw; border-radius: 10px; font-size: 1.13vw; margin-bottom: 1.29vw; color: #959595; width: calc(100% - 3.22vw);}
  .inputBoxWrap label { font-size: 0.81vw; color: #959595; padding: 0}
  input:focus ~ label { top: -0.5vw }
  /deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -0.5vw }
  /*остальные стили*/

  h2 { font-size: 2.58vw }
  h3 { color: #222721; font-size: 2.10vw }
  p { font-size: 1.13vw }
  a { color: #43AC34 }
  span { font-size: 0.81vw }
  div { font-size: 1.13vw }
  button { font-size: 1.21vw }
  label { font-size: 0.81vw }
  div.suggestions span { font-size: 1.21vw }

  .mobileOnly { display: none }
  .pcOnly { display: block }
  #steps > div { display: flex }
  /*.align { width: 96.77vw; margin: 0 auto; }*/
  .alignPDL { width: 96.77vw; margin: 0 auto; }
  h2 { }
  h3 { }
  a { }
  p { }
  #zform .sec_2 .pcOnly { display: block }
  #anketaSteps { display: flex; padding: 0; justify-content: space-between }
  #screenFormLayout{ width: 58.87vw }
  #screenFormLayout h2 { margin-bottom: 5.32vw; text-align: left; font-size: 1.94vw }
  #steps { padding: 2.66vw 12.58vw 0 }
  #steps > div { flex-direction: row; margin-bottom: 0 }
  #steps > div > div { display: flex; align-items: center; padding-right: 3.15vw }
  #steps > div > div > img { width: 1.45vw; height: 1.45vw; margin: 0 0.65vw 0 0 }
  #steps > div > div > span { color: #131515; opacity: 0.5; padding-left: 0.65vw; font-size: 0.81vw }
  #steps > div > div > label { }
  #steps > div > div > p {  color: #131515; opacity: 0.5; padding-left: 0.65vw; font-size: 0.81vw }
  #steps > div > div > label:last-child {  color: #131515; opacity: 0.5; padding-left: 0.65vw }
  #steps > div > div > label > a { color: #43AC34 }
  #steps > div > div > label > input { width: 1.45vw; height: 1.45vw; margin: 0 0.65vw 0 0}
  #steps .nextStepBlock { margin-bottom: 4.27vw; justify-content: flex-end; }
  #steps .nextStepBlock > p { display: flex; align-items: center }
  #steps .nextStepBlock > button { border-radius: 10px; width: 16.13vw; padding: 1.29vw 2.10vw; height: 4.03vw; margin: 0 0 0 1.94vw }

  /*.banner .mobileOnly {  display: block }*/
  /*.banner .pcOnly {  display: none }*/
  /*.banner {  padding-top: 6.18vw; padding-right: 7.50vw; padding-left: 7.50vw }*/
  /*.banner svg { width: 30vw }*/
  /*.banner .phone { top: 24vw; right: 2vw }*/
  /*.banner .phone>img { width: 47vw }*/
  /*.banner>div>p:first-child { font-size: 4.21vw; margin-bottom: 3vw }*/
  /*.banner>div>p:nth-child(2) { font-size: 3.95vw; margin-bottom: 5.26vw; line-height: 6vw }*/
  /*.banner>div>p:nth-child(4) { font-size: 1.5vw; padding-bottom: 3.95vw; padding-top: 3.95vw }*/
  /*.banner>div>p>span { font-size: 3.95vw; background-color: #ABE600; color: #0f5740; font-weight: bold }*/
}
@media (min-width: 1240px) {
  /*select,input{appearance: auto;}*/
  /*стили для полей*/
  .errorMsg { font-size: 10px; top: 36px; left: 23px; padding: 0 }
  .inputBoxWrap > input { padding: 12px 20px; font-size: 14px; margin-bottom: 16px ;width: calc(100% - 40px);}
  .inputBoxWrap label { font-size: 10px; left: 23px }
  input:focus ~ label { top: -10px }
  /deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -10px }
  /*остальные стили*/

  h2 { font-size: 29px }
  h3 { color: #222721; font-size: 32px }
  p { font-size: 14px }
  a { color: #43AC34; font-size: 12px }
  span { font-size: 10px }
  div { font-size: 14px }
  button { font-size: 15px }
  label { font-size: 10px }
  div.suggestions span { font-size: 15px }

  .alignPDL { width: 1200px; margin: 0 auto; }
  .mobileOnly { display: none }
  .pcOnly { display: block }
  #steps > div { display: flex }
  a { }
  #zform{padding: 20px 0;}
  #zform .sec_2 .pcOnly { display: block }
  #anketaSteps { padding: 0; }
  #screenFormLayout{ width: 730px  }
  #screenFormLayout h2 { margin-bottom: 40px ;font-size: 32px }
  #steps { padding: 33px 110px 0 }
  #steps > div { margin-bottom: 48px }
  #steps > div > div { padding-right: 39px; margin-bottom: 0 }
  #steps > div > div > img { width: 18px; height: 18px; margin: 0 8px 0 0 }
  #steps > div > div > span { padding-left: 0 }
  #steps > div > div > label {  padding-left: 0 }
  #steps > div > div > p {  padding-left: 0; font-size: 10px }
  #steps > div > div > label > a {  }
  #steps > div > div > label > input { width: 18px; height: 18px; margin: 0 8px 0 0 }
  #steps .nextStepBlock { margin-bottom: 53px }
  #steps .nextStepBlock > p { }
  #steps .nextStepBlock > button { width: 200px; padding: 16px 26px; height: 50px; margin: 0 0 0 30px }

  /*.banner .mobileOnly { display: none }*/
  /*.banner .pcOnly { display: block }*/
  /*.banner { padding-top: 65px; padding-right: 0; padding-left: 0 }*/
  /*.banner>div { position: relative; margin: 0 auto; width: 1200px }*/
  /*.banner svg { width: 246px }*/
  /*.banner .phone { position: absolute; top: -20px; right: 102px }*/
  /*.banner .phone>img { width: 502px }*/
  /*.banner>div>p:first-child { font-size: 32px; margin-bottom: 26px }*/
  /*.banner>div>p:nth-child(2) { font-size: 30px; margin-bottom: 40px; line-height: 45px }*/
  /*.banner>div>p:nth-child(4) { font-size: 12px; padding-bottom: 30px; padding-top: 40px }*/
  /*.banner>div>p>span { font-size: 30px; background-color: #ABE600; color: #0f5740; font-weight: bold }*/

}

</style>
